export default __webpack_public_path__ + "static/media/36I-114272_-20441_0.bf90897e.jpg";